//namespace
window.QJTApp = window.QJTApp || { modules: {} };

QJTApp.modules.home             = QJTApp.modules.home || {};
QJTApp.modules.home.models      = QJTApp.modules.home.models || {};
QJTApp.modules.home.views       = QJTApp.modules.home.views || {};
QJTApp.modules.home.collections = QJTApp.modules.home.collections || {};
QJTApp.modules.home.routes      = QJTApp.modules.home.routes || {};

QJTApp.modules.home.routes.Router = Backbone.Router.extend({

  initialize: function() {
    console.log('Router initialized!');

    Backbone.history.start({pushState: true});
  },

  routes: {
    'teste' : 'testing',
    'posts/:id': 'postModal',
    '': 'index'
  },

  testing: function() {
    console.log('testing...');
  },

  postModal: function(id) {
    console.log('modal: id ' + id);
  },

  /*noCopy: function() {
    $('#copy').html('');
  },
  
  heirloomRoseMessage: function() {
    $('#copy').html('Heirloom Roses are great Mother`s Day flowers');
  },
  
  rainbowRoseMessage: function() {
    $('#copy').html('Choose Rainbow Roses for your wedding');
  },
  
  redRoseMessage: function() {
    $('#copy').html('On Valentine`s day, give that special someone Red Roses');
  },*/

  index: function() {
    console.log('index');
  }

});